// Utility to trigger a Google Analytics 4 purchase event using gtag
// Usage: sendPurchaseEvent({ transaction_id, value, currency })

export interface PurchaseEvent {
  transaction_id: string;
  value: number;
  currency: string;
}

/**
 * Sends a Google Analytics 4 purchase event using gtag.
 *
 * @param {{ transaction_id, value, currency }} event - An object containing the transaction ID, value, and currency for the purchase event.
 *
 * @example
 * sendPurchaseEvent({
 *   transaction_id: '1234',
 *   value: 50,
 *   currency: 'USD',
 * });
 */
export function sendPurchaseEvent({
  transaction_id,
  value,
  currency,
}: PurchaseEvent) {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "purchase", {
      transaction_id,
      value,
      currency,
    });
    (window as any).gtag("event", "conversion", {
      send_to: process.env.REACT_APP_CONVERSION_SENDER,
      transaction_id,
      value,
      currency,
    });
  }
}

export function sendLeadEventGTM(
  client: any,
  selectedProduct: any,
  selectedPrice: string
) {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "lead", {
      product: selectedProduct?.name,
      value: selectedPrice,

      currency: "RON",
      client_name: client.firstName + " " + client.lastName,
      client_email: client?.email,
      client_phone: client?.phone,
    });
  }
}
